module.exports = __webpack_public_path__ + "img/5.dd20bd73.png";